const topics = [
  { name: '国产剧', count: '2.3万讨论', icon: 'ri-tv-line' },
  { name: '动作片', count: '1.8万讨论', icon: 'ri-sword-line' },
  { name: '喜剧电影', count: '1.5万讨论', icon: 'ri-emotion-happy-line' },
  { name: '悬疑推理', count: '1.2万讨论', icon: 'ri-search-eye-line' },
  { name: '爱情剧', count: '9800+讨论', icon: 'ri-heart-line' },
  { name: '科幻大片', count: '8600+讨论', icon: 'ri-rocket-line' },
  { name: '日漫番剧', count: '7500+讨论', icon: 'ri-ghost-smile-line' },
  { name: '纪录片', count: '6200+讨论', icon: 'ri-earth-line' },
  { name: '韩剧热播', count: '5800+讨论', icon: 'ri-kakao-talk-line' },
  { name: '战争历史', count: '4900+讨论', icon: 'ri-history-line' },
  { name: '恐怖惊悚', count: '4100+讨论', icon: 'ri-ghost-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">热门话题</h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12">影视爱好者正在热聊的话题，看看有没有你感兴趣的</p>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.name}
              href="#carousel"
              className="group inline-flex items-center gap-2 bg-background-100 border border-background-200/70 rounded-full px-4 py-2.5 hover:border-accent-300 hover:bg-accent-50 transition-colors cursor-pointer"
            >
              <i className={`${topic.icon} text-primary-500 text-sm`}></i>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">{topic.name}</span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}